import "./src/styles/global.css";

const GA_MEASUREMENT_ID = "G-C6R6LY2MQ5";

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: location.pathname + location.search + location.hash,
  });
};
